(() => {
  angular
    .module('app.report')
    .controller('ReportController', Report);

  Report.$inject = [
    '$scope',
    '$window',
    '$timeout',
    '$interval',
    '$location',
    '$rootScope',
    'Report',
    'ModalService',
    'EventsService',
    'CampaignService',
    'CustomSegmentsService',
    'CampaignManagerService'
  ];

  function Report(
    $scope,
    $window,
    $timeout,
    $interval,
    $location,
    $rootScope,
    Report,
    ModalService,
    EventsService,
    CampaignService,
    CustomSegmentsService,
    CampaignManagerService
  ) {
    const vm = this;
    let allTrackpoints = [];
    let campaignLastRecalc = undefined;
    let originalCriteria = {};
    let originalTargets = {};
    let originalCampaign = {};
    let hasCustomTargeting = false;

    vm.initialCampaign = {
      ...initialCampaignData,
      isActive: initialCampaignData.status == 'active',
      lastUpdatedDate: initialCampaignData.last_updated && new Date(initialCampaignData.last_updated * 1000),
      lastUpdatedTimestamp: initialCampaignData.last_updated,
    };

    vm.isStandard = () => vm.initialCampaign.type === 'standard';

    vm.isDirty = false;
    vm.isCampaignClean = false;
    vm.isCampaignLoaded = false;
    vm.isCampaignLoading = false;
    vm.affinity = {};
    vm.overview = {
      impWeekly: {}
    };

    const pid = parseInt($window.location.pathname.split('/')[2]);
    vm.campaignIdParam = { id: pid };

    const waitingForSources = () => {
      if (vm.isStandard() || !vm.campaign) {
        return false;
      }

      const { sources } = vm.campaign;
      // return sources.every(({ status }) => status === 'pending' || status === 'error');
      return sources.some(({ status }) => status === 'error'); // APSD-906
    };

    initIntegratedCampaignSources();
    function initIntegratedCampaignSources() {
      const campaign = vm.campaign || vm.initialCampaign;

      const getSourceStatus = provider => {
        const { sources } = campaign;
        const source =  sources && sources.find(item => item.provider === provider);

        if (source && source.status && !vm.campaign) {
          return 'waiting';
        }

        return source && source.status;
      }

      vm.sourceYoutubeStatus = getSourceStatus('youtube');
      vm.sourceFacebookStatus = getSourceStatus('facebook');
      vm.sourceAudiencereportStatus = getSourceStatus('audiencereport');
    }

    init(true);
    function init(initialDirty, showAlert) {
      loadCampaignStatus()
        .then(({ data }) => {
          if (!data) return false;

          hasCustomTargeting = data.customTargeting;
          vm.isRouteLoading = false;
          vm.ERTime = (data.estimatedRecalculationTime || 30) + 10;
          vm.csUnavailable = hasCustomTargeting && !data.csAvailable;
          vm.isCampaignClean = data.status !== 'dirty';
          vm.isDirty = !vm.csUnavailable && initialDirty;

          const timeout = 1;
          const interval = $interval(() => {
            if (!vm.isCampaignClean || waitingForSources()) {
              reloadCampaignStatus(interval, showAlert);
            } else if (vm.isCampaignClean && vm.isCampaignLoaded) {
              clearPreloader(interval, showAlert);
            } else if (vm.campaign && vm.campaign.isClean && !vm.isCampaignLoaded && !vm.isCampaignLoading) {
              vm.subActivate && vm.subActivate();
            }
          }, timeout*1000);

          activate();
        });
    }

    function loadCampaignStatus() {
      return Report.getCampaignStatus(vm.campaignIdParam).$promise;
    }

    function reloadCampaignStatus(interval, showAlert) {
      loadCampaignStatus()
        .then(({ data }) => {
          if (data) {
            const { status, customTargeting, csAvailable } = data;
            hasCustomTargeting = customTargeting;
            vm.csUnavailable = hasCustomTargeting && !csAvailable;
            vm.isCampaignClean = status !== 'dirty';
          }

          if (vm.csUnavailable) {
            clearPreloader(interval, showAlert);
          }

          if ((vm.campaign && !vm.campaign.isClean) || !vm.isCampaignClean || waitingForSources()) {
            activate();
          } else if (vm.isCampaignClean && vm.isCampaignLoaded) {
            clearPreloader(interval, showAlert);
          }
        });
    }

    vm.isNoData = () => !vm.campaign.hasData && !vm.campaign.isDeleted && vm.campaign.isClean;

    function loadCampaignData() {
      // query general campaign data
      vm.campaignPromise = CampaignService.get(vm.campaignIdParam).$promise;

      vm.campaignPromise.then(campaign => {
        if (campaign.target) {
          originalCriteria = { ...campaign.target.criteria };
        }
        originalTargets = { ...campaign.targetSegment };
        originalCampaign = Object.assign({}, campaign);
        CampaignManagerService.setCampaignData(originalCampaign);

        const reachBasedOnEventType = campaign.reachBuildEventType || campaign.calculatedReachBuildEventType;
        vm.reachBasedOn = reachBasedOnEventType &&
          EventsService.getAllowedEventTypes().find(({ type }) => type === reachBasedOnEventType).labelName;

        vm.campaign = {
          ...campaign,
          hasCustomTargeting,
          hasData: campaign.status != 'new' && campaign.events !== 0,
          isClean: campaign.status != 'dirty',
          isArchived: campaign.status == 'archived',
          isActive: campaign.status == 'active',
          isDeleted: campaign.status == 'deleted',
          lastUpdatedDate: campaign.last_updated ? new Date(campaign.last_updated * 1000) : undefined,
          lastUpdatedTimestamp: campaign.last_updated,
          startDateInTheFuture: campaign.start ? (new Date(campaign.start) > new Date()) : undefined,
          specifiedStartDate: campaign.start ? new Date(campaign.start) : undefined,
          endDate: campaign.end ? new Date(campaign.end) : (campaign.c_end ? new Date(campaign.c_end) : undefined),
          startDate: campaign.start ? new Date(campaign.start) : (campaign.c_start ? new Date(campaign.c_start) : undefined),
          startWeek: 1,
          dqProcessingStartDate: new Date(Date.UTC(2014, 8, 20)),
          endDateCalculated: campaign.c_end ? new Date(campaign.c_end) : undefined,
          startDateCalculated: campaign.c_start ? new Date(campaign.c_start) : undefined,
          totalEvents: campaign.events ? campaign.events : undefined,
          country: campaign.panel_country,
          referenceId: campaign.metadata ? campaign.metadata.referenceId : undefined,
          reportItems: campaign.ris,
          activeMetrics: campaign.qualityMetrics,
        };

        hasUnavailableCustomSegments(campaign);

        if (vm.isStandard()) {
          // prepare promises for delivery & support metrics
          vm.trackpointsPromise = CampaignService.getTrackpointsWithEventCount(vm.campaignIdParam).$promise;
          vm.trackpointsPromise.then((response) => {
            allTrackpoints = response.data;

            const inactiveTrackpoints = _.where(allTrackpoints, { active: false });
            vm.excludedTrackpointsCount = inactiveTrackpoints.length;
          });
        } else {
          initIntegratedCampaignSources();
        }

      });
    }

    function loadReportData() {
      //prepare promises for reach tab child controller
      vm.reportPromise = Report.getReportData(vm.campaignIdParam).$promise;

      vm.reportPromise.then(({ data }) => {
        if (data && data.ex) {
          console.error(data);
        }

        vm.affinity.details = angular.isDefined(data) ? data.affinityDetails : undefined;
      });
    }

    function activate() {
      vm.isCampaignLoaded = false;

      loadCampaignData();
      loadReportData();
    }

    function hasUnavailableCustomSegments(campaign) {
      campaign.customSegments.forEach(segment => {
        if (!vm.campaign.hasUnavailableSegments) {
          const { c_start, panel_country, start, } = campaign;

          CustomSegmentsService.isAvailable({
            csid: segment.csid,
            startDate: start ? new Date(start) : (c_start ? new Date(c_start) : new Date()),
            countryCode: panel_country
          }).$promise.then(({ data }) => {
            if (data && !data.available && !vm.campaign.hasUnavailableSegments) {
              vm.campaign.hasUnavailableSegments = true;
            }
          });
        }
      });
    }

    function clearPreloader(interval, showAlert) {
      $interval.cancel(interval);
      vm.isLoaderFadeout = true;
      $timeout(() => {
        vm.isDirty = false;
        runUpdateWatcher();

        if (showAlert && document.visibilityState !== 'visible') {
          faviconAlert(true);
        }
      }, 1000);
    }

    function runUpdateWatcher() {
      const reload = $interval(() => {
        if (vm.campaign && vm.campaign.isArchived) {
          $interval.cancel(reload);
        } else if (vm.isCampaignLoaded) {
          loadCampaignStatus()
            .then(({ data }) => {
              if (!data) return false;
              const { lastRecalc } = data.dates;

              vm.hasUpdate = campaignLastRecalc && (campaignLastRecalc !== lastRecalc);
              campaignLastRecalc = lastRecalc;
              if (vm.hasUpdate) {
                init(false, true);
              }
            });
        }
      }, TIME.DATA_REQUEST);
    }

    vm.getProvider = provider => {
      const sources = {
        audiencereport: 'AudienceReport',
        facebook: 'Facebook',
        youtube: 'Youtube',
        adwords: 'Youtube',
        dv360: 'Youtube',
      };
      return sources[provider];
    };

    $rootScope.$on('$routeChangeStart', () => {
      vm.isRouteLoading = true
    });

    $rootScope.$on('$routeChangeSuccess', () => {
      if (vm.reportPromise) {
        vm.reportPromise.then(() => {
          vm.isRouteLoading = false
        });
      }
    });

    vm.tabs = [
      'overview',
      'profile',
      'reach',
      'affinity',
      'events',
      'delivery',
      'quality',
      'support',
    ];

    vm.setTab = (index, initial) => {
      if (((!vm.isDirty && vm.isCampaignLoaded) || initial) &&
            !vm.isActiveTab(index)) {

        if (vm.qualityCache) {
          vm.qualityCache.selectedMetric = '';
        }

        $location.path(vm.tabs[index]);
      }
    };

    vm.isActiveTab = index => ((vm.isDirty || !vm.isCampaignLoaded) ?
      false : vm.currentTab.split('/')[0] === vm.tabs[index]);

    if ($location.path() === '/') {
      vm.setTab(0, true);
    }

    $scope.$on('$locationChangeSuccess', () => {
      vm.currentTab = $location.path().replace('/', '');
    });

    vm.openDeleteModal = () => {
      ModalService
        .showModal({
          templateUrl: vm.campaign.sourceFor.length !== 0 ?
            '../../assets/js/app/campaign/modals/deleteWithSources.html' :
            '../../assets/js/app/campaign/modals/delete.html',
          controller: 'DeleteModalController',
          controllerAs: 'deleteModal',
          inputs: {
            campaignCount: 1,
            sourceFor: vm.campaign.sourceFor,
          }
        })
        .then(modal => {
          modal.element.modal();
          modal.close.then(result => {
            if (result) {
              const service = new CampaignService();
              service.pid = pid;
              service.name = vm.campaign && vm.campaign.name;
              CampaignService.delete(service, () => {
                Notification.onCampaignDeleted(service.pid, service.name);
                $window.location.href = document.referrer;
              });
            }
          });
        });
    };

    vm.openExportModal = function () {
      ModalService
        .showModal({
          templateUrl: `../../assets/js/app/report/modals/export.html?v=${window.BUILD_VERSION}`,
          controller: 'ExportModalController',
          controllerAs: 'exportModal',
          inputs: {
            pid,
            campaign: vm.campaign,
          }
        })
        .then(function (modal) {
          modal.element.modal();
          modal.close.then(function (result) { });
        });
    };

    vm.openFilterModal = function () {
      ModalService
        .showModal({
            templateUrl: `../../assets/js/app/report/modals/filter.html?v=${window.BUILD_VERSION}`,
            controller: 'FilterModalController',
            controllerAs: 'filterModal',
            inputs: {
              pid,
              allTrackpoints,
              includedReportItems: vm.campaign.reportItems,
            }
        })
        .then(function (modal) {
          modal.element.modal();
          modal.close.then(result => {});
        });
    };

    vm.openReferenceModal = function () {
      ModalService
        .showModal({
          templateUrl: '../../assets/js/app/report/modals/reference.html',
          controller: 'ReferenceModalController',
          controllerAs: 'referenceModal',
          inputs: {
            pid,
            referenceId: vm.campaign.referenceId
          }
        })
        .then(function (modal) {
          modal.element.modal();
          modal.close.then(function (result) {
            vm.campaign.referenceId = result;
          });
        });
    };

    function generateReportItemsFromTrackpoints(trackpoints) {
      const reportItems = [];

      angular.forEach(trackpoints, trackpoint => {
        angular.forEach(trackpoint.eventTypes, isPresent, eventType => {
          if (isPresent) {
            reportItems.push({
              name: trackpoint.name,
              cid: trackpoint.cid,
              eventType: eventType,
              evid: `${eventType}:${trackpoint.cid}:${trackpoint.tailcode}`,
              tailcode: trackpoint.tailcode,
              active: trackpoint.active,
              properties: trackpoint.properties
            });
          }
        })
      });

      return reportItems;
    }

    function onSave() {
      if (vm.sidebar.targetChanged()) {
        $rootScope.campaignBusy = true;

        const campaignSavePromise = CampaignManagerService.updateCampaign();
        campaignSavePromise.then(
          // on success
          response => {
            $rootScope.campaignBusy = false;
            $window.location.reload();
          },
          // on failure
          response => {
            $rootScope.campaignBusy = false;
            CampaignManagerService.setCampaignData(originalCampaign);
            console.error(response.data.error);
            // alert(response.data.error.ex);
          }
        );
      }
    }

    vm.sidebar = {
      openCustomSegments: false,
      openCustomSegmentsTargetGroup: false,
      openTargetGroup: false,
      onToggle: (panel) => {
        if (panel === 'openTargetGroup' && vm.sidebar[panel]) {
          CampaignManagerService.setCampaignData(originalCampaign);
        }

        if (panel === 'openCustomSegments' || panel === 'openTargetGroup') {
          $rootScope.dropSidebarChanges = !$rootScope.dropSidebarChanges;
          $('body').toggleClass('freeze');
        }

        vm.sidebar[panel] = !vm.sidebar[panel];
      },
      onSaveSegment: () => {
        vm.sidebar.openCustomSegments = !vm.sidebar.openCustomSegments;
        $('body').toggleClass('freeze');
        onSave();
      },
      onSaveTarget: () => {
        vm.sidebar.openTargetGroup = !vm.sidebar.openTargetGroup;
        $('body').toggleClass('freeze');
        onSave();
      },
      isSaveButtonDisabled: () => !CampaignManagerService.canTouchCampaign(),
      targetChanged: () => {
        const campaignData = CampaignManagerService.getCampaignData();
        if (campaignData) {
          return !_(originalTargets).isEqual(campaignData.targetSegment) ||
            (campaignData.target && !_(originalCriteria).isEqual(campaignData.target.criteria));
        }
        return false;
      },
    };
  }
})();
